import { render, staticRenderFns } from "./appFooter.vue?vue&type=template&id=53439336&scoped=true"
import script from "./appFooter.vue?vue&type=script&lang=js"
export * from "./appFooter.vue?vue&type=script&lang=js"
import style0 from "./appFooter.vue?vue&type=style&index=0&id=53439336&prod&lang=scss&scoped=true"
import style1 from "./appFooter.vue?vue&type=style&index=1&id=53439336&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53439336",
  null
  
)

export default component.exports